import { Injectable } from '@angular/core';
import { 
    HttpInterceptor, 
    HttpRequest, 
    HttpHandler, 
    HttpClient, 
    HttpEvent, 
    HttpErrorResponse, 
    HttpContextToken, 
    HttpContext 
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

@Injectable()
export class SubscriptionStatusInterceptor implements HttpInterceptor {

  private readonly username = StorageManager.getUser()?.username ?? '';

  private readonly CHECK_SUBSCRIPTION_URL = 
    !environment.serverUrl.includes('localhost') ? 
      environment.serverUrl + 'ws/index.php?p1=user&p2=checkSubscriptionStatus' : 
      environment.serverUrl + 'user/' + this.username + '/checkSubscriptionStatus';

  private readonly SKIP_SUBSCRIPTION_CHECK = new HttpContextToken<boolean>(() => false);

  constructor(private readonly router: Router, private readonly http: HttpClient) {void http;}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.appName !== 'agrogestSIEX' || req.context.get(this.SKIP_SUBSCRIPTION_CHECK) || this.username === '') {
      return next.handle(req);
    }

    return this.http.get<{ data: {tipo_suscripcion: string, subscription_status: string} }>(
        this.CHECK_SUBSCRIPTION_URL, 
    {
      params: { username: this.username },
      context: new HttpContext().set(this.SKIP_SUBSCRIPTION_CHECK, true)
    }).pipe(
      switchMap(subscription => {
        if (
          subscription.data.subscription_status === 'expired' || 
          subscription.data.subscription_status === null ||
          subscription.data.subscription_status === ''
        ) {
            StorageManager.deleteUser();
            this.router.navigate(['register'], {queryParams: { estado: 'expired' }});
        }
        
        return next.handle(req);
      }),
      catchError((error: HttpErrorResponse) => 
         throwError(() => error)
      )
    );
  }
}
